export default __webpack_public_path__ + "ba6a1a0.png";